export default Object.freeze({
  Cancelled: 1,
  Reversed: 2,
  Omitted: 3,
  Paid: 4,
  InSettlement: 5,
  EligibleUnsettled: 6,
  DuePendingApproval: 7,
  NotYetDue: 8,
  Inconsistent: 9,
});
